module.exports = __webpack_public_path__ + "static/facturacion-95bb4513e73c3b118cf7202e5a35e846.png";